import React from 'react';
import FullScreenSpinner from '../../global/components/FullScreenSpinner';

const SpinnerHOC = (propName) => (WrappedComponent) => {
    return class Default extends React.Component {
        isEmpty(prop) {
            return (prop === null || prop === undefined || (prop.hasOwnProperty('length') && prop.length === 0) || (prop.constructor === Object && Object.keys(prop).length === 0));
        }
        render() {
            return this.isEmpty(this.props[propName])
                ? <FullScreenSpinner />
                : <WrappedComponent {...this.props}/>
        }
    }
}

export default SpinnerHOC;
